module.exports = __webpack_public_path__ + "static/media/advogado.17197e1c.jpeg";